<template>
  <b-overlay :show="showLoading">
    <b-row>
      <b-col cols="12">
        <b-card v-for="item in pageData">

          <b-form-group
              label-for="blog-content"
              class="mb-2"
          >
            <div class="my-1 d-flex">
              <b-form-checkbox
                  v-model="item.content"
                  class="custom-control-primary"
                  name="isActive"
                  switch
              />
              <span>{{ item.title }}</span>
            </div>
          </b-form-group>

          <!-- Action Buttons -->
          <b-button
              variant="primary"
              class="mt-1 mb-sm-0 mr-0 mr-sm-1 col-12 col-md-2"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              @click="updateSection(item)"
          >
            ثبت
          </b-button>

        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import {
  BCard, BRow, BCol,BButton, BOverlay,BFormGroup,BFormCheckbox
} from 'bootstrap-vue'

import {PostCreateRequest} from "@/libs/Api/Post";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {StaticPageGetByTypeRequest, StaticPageUpdateRequest} from "@/libs/Api/StaticPage";
export default {
  name: "contactUs",
  title: 'ویرایش امکانات خرید - پنل ادمین بنفشه باقری',
  data(){
    return{
      pageData:null,
      createData:{
        isDeleted: false,
        postId: 0,
        userId: 0,
        content: null,
      },
      showLoading:false,
    }
  },
  async created(){
    await this.getData()
  },
  methods:{
    async getData(){
      let _this = this;
      _this.showLoading = true;

      let type = 10;

      let staticPageGetByTypeRequest = new StaticPageGetByTypeRequest(_this);
      staticPageGetByTypeRequest.setType(type);
      await staticPageGetByTypeRequest.fetch(function (content){
        _this.showLoading = false;
        _this.pageData = content;
      },function (error){
        _this.showLoading = false;
        console.log(error)
      })
    },
    async updateSection(param){
      let _this = this;

      _this.showLoading = true;

      let staticPageUpdateRequest = new StaticPageUpdateRequest(_this);
      staticPageUpdateRequest.setParams(param);
      await staticPageUpdateRequest.fetch(function (content){
        _this.showLoading=false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `عملیات انجام شد.`,
          },
        })
        _this.getData();
      },function (error){
        _this.showLoading=false;
        console.log(error)
      })
    },
  },
  components:{
    BCard,
    BRow,
    BCol,
    BButton,
    BOverlay,
    BFormGroup,
    BFormCheckbox
  },
}
</script>

<style scoped>

</style>
